import BaseModel from "./BaseModel";
import CourseModuleVideo from "./CourseModuleVideo";

/**
 * CourseModule 
 */
export default class CourseModule extends BaseModel{

  constructor({
    id,
    title,
    description,
    timeInMinutes,
    course,
    courseModuleOrder,
    created_at,
    updated_at,
    deleted_at,
    videos,
  }) {
    super();

    this.id = id || null;
    this.title = title || null;
    this.description = description || null;
    this.timeInMinutes = timeInMinutes || null;
    this.course = course || null;
    this.courseModuleOrder = courseModuleOrder || null;
    this.created_at = created_at || null;
    this.updated_at = updated_at || null;
    this.deleted_at = deleted_at || null;
    this.videos = videos || null;
    
    if (this.videos)
      this.handleVideos();
  }

  /**
   * Parses this.videos to CourseModuleVideo objects array
   */
  handleVideos() {
    if (Array.isArray(this.videos)) {

      let videosArr = [];
      for (let file of this.videos) {
        videosArr.push(new CourseModuleVideo(file));
      }

      this.videos = videosArr;
    }
  }

  /**
   * Gets this.videos
   * @returns {Array|Null}
   */
  getVideos(){
    return this.videos;
  }

  /**
   * Tries to get this course module video by id
   * @param {integer} videoId
   * @returns {CourseModuleVideo|Null} 
   */
  getVideoById(videoId = null) {
    for (let videoObj of this.getVideos()) {
      if(videoObj.id == videoId)
        return videoObj;
    }
    return null;
  }
}